import {
  SET_DAY,
  SET_WEEK,
  SET_WEEK_RANGE,
  SET_DRAG_CELL,
  SET_ROSTER,
  TOGGLE_CALENDER,
  SET_DRAG_SHIFT,
  TOGGLE_DELETE,
  SET_SHIFT,
  TOGGLE_BULK_CONFIRM,
  TOGGLE_VIEW,
  SET_SELECTED,
  TOGGLE_CLOCK_MODAL,
  TOGGLE_DROP_MODAL,
  TOGGLE_REQ_MODAL,
  TOGGLE_SUMMARY_MODAL,
  TOGGLE_COPY,
  TOGGLE_CLOCKADD_MODAL,
  SET_ROTA_EMP,
  //
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  //
  SAVE_SETTINGS,
  SAVE_SETTINGS_SUCCESS,
  SAVE_SETTINGS_FAILURE,
  //
  CLOCK_IN,
  CLOCK_IN_SUCCESS,
  CLOCK_IN_FAILURE,
  //
  TOGGLE_APPROVE_MODAL,
  //
  UPDATE_CLOCKIN,
  UPDATE_CLOCKIN_SUCCESS,
  UPDATE_CLOCKIN_FAILURE,
  //
  APPROVE_DROP,
  APPROVE_DROP_SUCCESS,
  APPROVE_DROP_FAILURE,
  //
  UPDATE_REQUEST,
  UPDATE_REQUEST_SUCCESS,
  UPDATE_REQUEST_FAILURE,
  //
  APPROVE_SWAP,
  APPROVE_SWAP_SUCCESS,
  APPROVE_SWAP_FAILURE,
  //
  REJECT_DROP,
  REJECT_DROP_SUCCESS,
  REJECT_DROP_FAILURE,
  //
  REJECT_SWAP,
  REJECT_SWAP_SUCCESS,
  REJECT_SWAP_FAILURE,
  //
  COPY_ROSTER,
  COPY_ROSTER_SUCCESS,
  COPY_ROSTER_FAILURE,
  SET_COPY_DATA,
  TOGGLE_UPDATE,
  TOGGLE_AVAIL_MODAL,
  //
  ADD_CLOCK,
  ADD_CLOCK_SUCCESS,
  ADD_CLOCK_FAILURE,
  //
  GET_PAID_HOURS,
  GET_PAID_HOURS_SUCCESS,
  GET_PAID_HOURS_FAILURE,
  //
  GET_SETTINGS_HISTORY,
  GET_SETTINGS_HISTORY_SUCCESS,
  GET_SETTINGS_HISTORY_FAILURE,
  TOGGLE_HISTORY_MODAL,
  SET_ROTA_EMP_NAME,
  //
  CLAIM_SHIFT,
  CLAIM_SHIFT_SUCCESS,
  CLAIM_SHIFT_FAILURE,
  //
  GET_LOC_SETTINGS,
  GET_LOC_SETTINGS_SUCCESS,
  GET_LOC_SETTINGS_FAILURE,
  //
  SAVE_LOC_SETTINGS,
  SAVE_LOC_SETTINGS_SUCCESS,
  SAVE_LOC_SETTINGS_FAILURE,
} from "./constants";

export const setDay = (payload) => ({
  type: SET_DAY,
  payload,
});
export const setWeek = (payload) => ({
  type: SET_WEEK,
  payload,
});
export const setWeekRange = (payload) => ({
  type: SET_WEEK_RANGE,
  payload,
});
export const setDragCell = (payload) => ({
  type: SET_DRAG_CELL,
  payload,
});
export const setRoster = (payload) => ({
  type: SET_ROSTER,
  payload,
});
export const toggleCalender = (payload) => ({
  type: TOGGLE_CALENDER,
  payload,
});
export const setDragShift = (payload) => ({
  type: SET_DRAG_SHIFT,
  payload,
});
export const toggleDelete = (payload) => ({
  type: TOGGLE_DELETE,
  payload,
});
export const setShift = (payload) => ({
  type: SET_SHIFT,
  payload,
});
export const toggleBulkConfirm = (payload) => ({
  type: TOGGLE_BULK_CONFIRM,
  payload,
});
export const toggleView = (payload) => ({
  type: TOGGLE_VIEW,
  payload,
});
export const setSelected = (payload) => ({
  type: SET_SELECTED,
  payload,
});

export const getSettings = (payload, onGetSuccess) => ({
  type: GET_SETTINGS,
  payload,
  onGetSuccess,
});
export const getSettingsSuccess = (payload) => ({
  type: GET_SETTINGS_SUCCESS,
  payload,
});
export const getSettingsFailure = (payload) => ({
  type: GET_SETTINGS_FAILURE,
  payload,
});

export const saveSettings = (payload, onSave) => ({
  type: SAVE_SETTINGS,
  payload,
  onSave,
});
export const saveSettingsSuccess = (payload) => ({
  type: SAVE_SETTINGS_SUCCESS,
  payload,
});
export const saveSettingsFailure = (payload) => ({
  type: SAVE_SETTINGS_FAILURE,
  payload,
});

export const toggleClockModal = (payload) => ({
  type: TOGGLE_CLOCK_MODAL,
  payload,
});

export const clockin = (payload, onClockSuccess) => ({
  type: CLOCK_IN,
  payload,
  onClockSuccess,
});
export const clockinSuccess = (payload) => ({
  type: CLOCK_IN_SUCCESS,
  payload,
});
export const clockinFailure = (payload) => ({
  type: CLOCK_IN_FAILURE,
  payload,
});

export const toggleApproveModal = (payload) => ({
  type: TOGGLE_APPROVE_MODAL,
  payload,
});

export const updateClockin = (payload, onUpdateSuccess) => ({
  type: UPDATE_CLOCKIN,
  payload,
  onUpdateSuccess,
});
export const updateClockinSuccess = (payload) => ({
  type: UPDATE_CLOCKIN_SUCCESS,
  payload,
});
export const updateClockinFailure = (payload) => ({
  type: UPDATE_CLOCKIN_FAILURE,
  payload,
});

export const toggleDropModal = (payload) => ({
  type: TOGGLE_DROP_MODAL,
  payload,
});

export const approveDrop = (payload, onApproveDrop) => ({
  type: APPROVE_DROP,
  payload,
  onApproveDrop,
});
export const approveDropSuccess = (payload) => ({
  type: APPROVE_DROP_SUCCESS,
  payload,
});
export const approveDropFailure = (payload) => ({
  type: APPROVE_DROP_FAILURE,
  payload,
});

export const toggleReqModal = (payload) => ({
  type: TOGGLE_REQ_MODAL,
  payload,
});

export const updateRequest = (payload, onUpdateRequest) => ({
  type: UPDATE_REQUEST,
  payload,
  onUpdateRequest,
});
export const updateRequestSuccess = (payload) => ({
  type: UPDATE_REQUEST_SUCCESS,
  payload,
});
export const updateRequestFailure = (payload) => ({
  type: UPDATE_REQUEST_FAILURE,
  payload,
});

export const approveSwap = (payload, onApproveSwap) => ({
  type: APPROVE_SWAP,
  payload,
  onApproveSwap,
});
export const approveSwapSuccess = (payload) => ({
  type: APPROVE_SWAP_SUCCESS,
  payload,
});
export const approveSwapFailure = (payload) => ({
  type: APPROVE_SWAP_FAILURE,
  payload,
});

export const toggleSummaryModal = (payload) => ({
  type: TOGGLE_SUMMARY_MODAL,
  payload,
});

export const rejectDrop = (payload, onRejectDrop) => ({
  type: REJECT_DROP,
  payload,
  onRejectDrop,
});
export const rejectDropSuccess = (payload) => ({
  type: REJECT_DROP_SUCCESS,
  payload,
});
export const rejectDropFailure = (payload) => ({
  type: REJECT_DROP_FAILURE,
  payload,
});

export const rejectSwap = (payload, onRejectSwap) => ({
  type: REJECT_SWAP,
  payload,
  onRejectSwap,
});
export const rejectSwapSuccess = (payload) => ({
  type: REJECT_SWAP_SUCCESS,
  payload,
});
export const rejectSwapFailure = (payload) => ({
  type: REJECT_SWAP_FAILURE,
  payload,
});
//
export const toggleCopy = (payload) => ({
  type: TOGGLE_COPY,
  payload,
});
//
export const copyRoster = (payload, onCopy) => ({
  type: COPY_ROSTER,
  payload,
  onCopy,
});
export const copyRosterSuccess = (payload) => ({
  type: COPY_ROSTER_SUCCESS,
  payload,
});
export const copyRosterFailure = (payload) => ({
  type: COPY_ROSTER_FAILURE,
  payload,
});
export const setCopyData = (payload) => ({
  type: SET_COPY_DATA,
  payload,
});
export const toggleUpdate = (payload) => ({
  type: TOGGLE_UPDATE,
  payload,
});
export const toggleAvailModal = (payload) => ({
  type: TOGGLE_AVAIL_MODAL,
  payload,
});

export const toggleClockAddModal = (payload) => ({
  type: TOGGLE_CLOCKADD_MODAL,
  payload,
});

//
export const addClock = (payload, onAdd) => ({
  type: ADD_CLOCK,
  payload,
  onAdd,
});
export const addClockSuccess = (payload) => ({
  type: ADD_CLOCK_SUCCESS,
  payload,
});
export const addClockFailure = (payload) => ({
  type: ADD_CLOCK_FAILURE,
  payload,
});

//
export const getPaidHours = (payload, onGet) => ({
  type: GET_PAID_HOURS,
  payload,
  onGet,
});
export const getPaidHoursSuccess = (payload) => ({
  type: GET_PAID_HOURS_SUCCESS,
  payload,
});
export const getPaidHoursFailure = (payload) => ({
  type: GET_PAID_HOURS_FAILURE,
  payload,
});

//
export const getSettingsHistory = (payload) => ({
  type: GET_SETTINGS_HISTORY,
  payload,
});
export const getSettingsHistorySuccess = (payload) => ({
  type: GET_SETTINGS_HISTORY_SUCCESS,
  payload,
});
export const getSettingsHistoryFailure = (payload) => ({
  type: GET_SETTINGS_HISTORY_FAILURE,
  payload,
});

export const toggleHistoryModal = (payload) => ({
  type: TOGGLE_HISTORY_MODAL,
  payload,
});

export const setRotaEmp = (payload) => ({
  type: SET_ROTA_EMP,
  payload,
});

export const setRotaEmpName = (payload) => ({
  type: SET_ROTA_EMP_NAME,
  payload,
});

export const claimShift = (payload, onClaim) => ({
  type: CLAIM_SHIFT,
  payload,
  onClaim,
});
export const claimShiftSuccess = (payload) => ({
  type: CLAIM_SHIFT_SUCCESS,
  payload,
});
export const claimShiftFailure = (payload) => ({
  type: CLAIM_SHIFT_FAILURE,
  payload,
});

export const getLocSettings = (payload, onGet) => ({
  type: GET_LOC_SETTINGS,
  payload,
  onGet,
});
export const getLocSettingsSuccess = (payload) => ({
  type: GET_LOC_SETTINGS_SUCCESS,
  payload,
});
export const getLocSettingsFailure = (payload) => ({
  type: GET_LOC_SETTINGS_FAILURE,
  payload,
});

export const saveLocSettings = (payload, onSave) => ({
  type: SAVE_LOC_SETTINGS,
  payload,
  onSave,
});
export const saveLocSettingsSuccess = (payload) => ({
  type: SAVE_LOC_SETTINGS_SUCCESS,
  payload,
});
export const saveLocSettingsFailure = (payload) => ({
  type: SAVE_LOC_SETTINGS_FAILURE,
  payload,
});
